export default "__VITE_ASSET__oVZW86ub__"